// src/pages/Reports/IssuanceReporting/PeriodSummaryClosing/index.tsx
// README.md mục 7 — trang "Tổng hợp & Chốt kỳ": RPT-017 (tổng hợp theo kỳ xổ, dạng thẻ số liệu),
// RPT-018 (chốt kỳ, có workflow xác nhận). Dùng chung 1 state `planId` giữa 2 tab (chọn 1 lần).

import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import BreadCrumb from 'Components/Common/BreadCrumb';
import { useBrandingTitle } from 'hooks';
import PeriodSummaryTab from './PeriodSummaryTab';
import PeriodClosingTab from './PeriodClosingTab';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

type TabKey = 'summary' | 'closing';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'summary', label: st('tong_hop_theo_ky_label') },
  { key: 'closing', label: st('chot_ky_label') },
];

const PeriodSummaryClosingPage: React.FC = () => {
  useBrandingTitle(st('tong_hop_chot_ky_text'));
  const [activeTab, setActiveTab] = useState<TabKey>('summary');
  const [planId, setPlanId] = useState('');

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={st('tong_hop_chot_ky_text')} pageTitle={st('bao_cao_phat_hanh_text')} />

        <Card>
          <CardHeader className="card-header border-0">
            <Nav tabs className="nav-tabs-custom card-header-tabs flex-wrap">
              {TABS.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === tab.key })}
                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </CardHeader>
          <CardBody>
            {activeTab === 'summary' && <PeriodSummaryTab planId={planId} onPlanIdChange={setPlanId} />}
            {activeTab === 'closing' && <PeriodClosingTab planId={planId} onPlanIdChange={setPlanId} />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PeriodSummaryClosingPage;
